import React from 'react';

import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import PaymentMethodSelect, { HoverTheme } from 'components/payment-method-select';
import { usePrepaidsPaymentMethods } from 'hooks/prepaid/use-prepaids-payment-methods';
import { usePaymentContext } from 'state/payment';
import { useUIContext } from 'state/ui';

import { InstructionText, LoadContainer, ReloadExplanationText, ReloadWrapper } from './styled';
import { IBasePrepaidMethodReloadProps } from './types';

const PrepaidMethodReload: React.FC<IBasePrepaidMethodReloadProps> = ({ reloadAmount }) => {
  const { formatMessage } = useIntl();
  const { formatCurrencyForUser } = useUIContext();
  const { setPrepaidReloadPaymentMethodId } = usePaymentContext();
  const navigate = useNavigate();
  const formattedReloadAmount = formatCurrencyForUser(reloadAmount);
  const {
    nonSelectedReloadPaymentMethods,
    selectedReloadPaymentMethod,
  } = usePrepaidsPaymentMethods();

  return (
    <ReloadWrapper>
      <ReloadExplanationText tabIndex={0}>
        {`${formatMessage(
          { id: 'reloadExplanation.th' },
          {
            reloadAmount: formattedReloadAmount,
          }
        )} `}
        <span>
          {formatMessage(
            { id: 'youWillBeCharged' },
            {
              reloadAmount: formattedReloadAmount,
            }
          )}
        </span>
      </ReloadExplanationText>
      <LoadContainer>
        <InstructionText id="payment-method-loads-with">
          {formatMessage({ id: 'loadWith' })}:
        </InstructionText>
        <PaymentMethodSelect
          onOptionClick={setPrepaidReloadPaymentMethodId}
          nonSelectedMethods={nonSelectedReloadPaymentMethods}
          selectedMethod={selectedReloadPaymentMethod}
          hoverTheme={HoverTheme.LIGHT}
          onNavigateClick={(e, route) => navigate(route)}
        />
      </LoadContainer>
    </ReloadWrapper>
  );
};

export default PrepaidMethodReload;
